import styled from 'styled-components';
import ViralTrackingPixel from '../viral-tracking/ViralTrackingPixel';
import { getTrackedIntermediateUrl, getTrackedSignupUrl } from '../viral-tracking/viral-urls';
import { Flow } from 'signup-constants/Flow';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Flex } from 'foundations-components/components/Flex';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledViralLink = styled.a.withConfig({
  displayName: "ViralLink__StyledViralLink"
})(({
  theme,
  typography
}) => {
  return Object.assign({
    textDecoration: 'none',
    color: theme['color']['text-core-default'],
    '&:hover': {
      textDecoration: 'none'
    }
  }, theme['typography'][typography || 'heading-25'], {
    fontWeight: theme['typography']['display-100']['fontWeight'],
    strong: Object.assign({}, theme['typography'][typography || 'heading-25'], {
      fontWeight: theme['typography']['display-100']['fontWeight'],
      textDecoration: 'underline',
      color: theme['color']['fill-primary-default'],
      '&:hover': {
        textDecoration: 'none'
      }
    })
  });
});
const ViralLink = ({
  children,
  environment = 'prod',
  flow = Flow.Crm,
  portalId,
  viralLinkType,
  additionalParams,
  isExternalLink,
  intermediatePage,
  use,
  typography,
  justifyContent = 'start',
  ariaLabel,
  iconSize = '500'
}) => {
  const href = intermediatePage ? getTrackedIntermediateUrl({
    redirectPage: intermediatePage,
    viralLinkType,
    environment,
    portalId,
    additionalParams
  }) : getTrackedSignupUrl({
    flow,
    viralLinkType,
    environment,
    additionalParams
  });
  if (use === 'primary') {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledViralLink, {
        href: href,
        target: "_blank",
        rel: "noopener nofollow",
        "data-test-id": `viral-link-${viralLinkType}`,
        "aria-label": ariaLabel,
        typography: typography,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: justifyContent,
          children: [/*#__PURE__*/_jsx(IconHolder, {
            "data-test-id": `spocket-icon-${viralLinkType}`,
            icon: SprocketIcon,
            color: 'fill-brand-default',
            size: iconSize,
            padding: "0",
            marginInlineEnd: "50",
            marginBlockStart: "50"
          }), /*#__PURE__*/_jsx("span", {
            children: children
          })]
        })
      }), /*#__PURE__*/_jsx(ViralTrackingPixel, {
        environment: environment,
        portalId: portalId,
        viralLinkType: viralLinkType,
        isExternalLink: isExternalLink
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("a", {
      href: href,
      target: "_blank",
      rel: "noopener nofollow",
      "data-test-id": `viral-link-${viralLinkType}`,
      "aria-label": ariaLabel,
      children: children
    }), /*#__PURE__*/_jsx(ViralTrackingPixel, {
      environment: environment,
      portalId: portalId,
      viralLinkType: viralLinkType,
      isExternalLink: isExternalLink
    })]
  });
};
export default ViralLink;